var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, Columns, EmptyState, FlexBox, Spinner, } from '@dixa/lib-shared-habla';
import { analyticsApi } from 'apis/analytics';
import { useBreakpointValue } from 'utils/mediaQuery';
import styles from './analytics.view.module.scss';
import { AnalyticsSidenav, analyticsSidenavWidth, } from './components/sidenav/analyticsSidenav';
export const AnalyticsView = ({ children }) => {
    const { dashboards, isLoading, isUninitialized, isError, refetch } = analyticsApi.useReadDashboardsQuery(undefined, {
        selectFromResult: (_a) => {
            var { data } = _a, rest = __rest(_a, ["data"]);
            return (Object.assign(Object.assign({}, rest), { dashboards: data === null || data === void 0 ? void 0 : data.data.dashboards }));
        },
    });
    const isSmallScreen = useBreakpointValue({ base: true, md: false });
    /** Renders the appropriate content based on the status of the API request. */
    const renderContent = () => {
        if (isUninitialized || isLoading) {
            return (_jsxs(FlexBox, Object.assign({ flexDirection: "column", height: "100%", alignItems: "center", justifyContent: "center", gap: "400" }, { children: [_jsx(Spinner, {}), _jsx(EmptyState, { title: "Initializing...", description: "Please wait a moment", icon: null })] })));
        }
        // When the request failed or no dashboards were returned.
        if (isError || (dashboards && dashboards.length === 0)) {
            return (_jsx(FlexBox, Object.assign({ flexDirection: "column", height: "100%", alignItems: "center", justifyContent: "center" }, { children: _jsx(EmptyState, { title: "Something went wrong", description: "We're experiencing some issues, try again or reload the page. If this issue persists, please contact support.", icon: "exclamation", iconColor: "red.500", buttonProps: {
                        children: 'Try again',
                        onClick: refetch,
                    } }) })));
        }
        return children;
    };
    return (_jsx("div", Object.assign({ className: styles.root }, { children: _jsxs(Columns, { children: [_jsx(Column, Object.assign({ size: isSmallScreen ? 0 : analyticsSidenavWidth }, { children: _jsx(Column.Row, Object.assign({ size: 1, noHorizontalPadding: true, noVerticalPadding: true }, { children: _jsx(AnalyticsSidenav, { isExpandable: !isLoading }) })) })), _jsx(Column, { children: _jsx(Column.Row, Object.assign({ size: 1, noHorizontalPadding: true, noVerticalPadding: true }, { children: renderContent() })) })] }) })));
};
